import styled from 'styled-components';

export type PropsLockStatus = {
  text?: string;
  roleStatus?: {
    text?: string;
    lock?: boolean;
  } | null;
  lockStatus?: {
    text?: string;
    lock?: boolean;
  };
  date?: Date | string;
  code?: string;
};

export default styled.div<PropsLockStatus>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  .display-none {
    display: none;
  }
  .box-status {
    display: flex;
    align-items: center;
    .text {
      font-size: 20px;
      letter-spacing: 0;
      line-height: 30px;
      font-weight: 600;
    }
    .status {
      border-radius: 4px;
      height: 20px;
      width: 80px;
      font-size: 12px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0;
      color: white;
      background-color: #e65050;
      &.lock {
        background-color: #69b362;
      }
    }
    .lock-status {
      margin-left: 24px;
    }
    .role-status {
      margin-left: 16px;
    }
  }
  .code {
    font-size: 12px;
    letter-spacing: 0;
    line-height: 18px;
    color: #666666;
  }
`;
